import React from 'react'
import Container from './Container'

const ContainerSwitch = ( {container, ...props} ) => {
    return (

        <React.Fragment>
        {(() => {
            switch (container.name) {
              default:
                return <Container container={container} {...props} />;
            }
          })()}
        </React.Fragment>
    )
}

export default ContainerSwitch
